import CRUDService from 'src/services/CRUDService';

export interface Campaign {
  id: number;
  sponsorId: string;
  filters: object;
  educationPhase: string;
  name: string;
  campaignFollowsCount?: number;
  startDate: string;
  endDate: string;
}

export default new CRUDService<Campaign>({baseUrl: '/v1/campaigns', useJWT: true});
